export enum EstadosFacturacion {
    Trialing = "trialing", //periodo de prueba gratis
    Active = "active",   //pagando normalmente
    PastDue = "past_due", //el cobro fallo pero sigue dentro del periodo de gracia

    Canceled = "canceled",
    UUnpaid = "unpaid",
    Incomplete = "incomplete",
    IncompleteExpired = "incomplete_expired"
}

export const EstadosFacturacionValidos = [EstadosFacturacion.Trialing, EstadosFacturacion.Active, EstadosFacturacion.PastDue]

export const EstadosFacturacionInValidos = [EstadosFacturacion.Canceled, EstadosFacturacion.UUnpaid, EstadosFacturacion.Incomplete, EstadosFacturacion.IncompleteExpired]

export const isValidEstadoFacturacion = (estado: any) => {
    if (!estado) return false

    return EstadosFacturacionValidos.includes(estado)
}